import { Component, OnInit, DOCUMENT } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable, Subject, of } from 'rxjs';
import { Router, RouterLink } from '@angular/router';
import { PassengerInfoService } from '../Services/passengerInfo.service';
import { BookingInfoProperties, BookingPassengerInfoProperties, SectorInformationProperties, TaxDetailsProperties, PassengerCreationResponse, TravelPreference_ServiceType, TravelPreference_MealList, TravelPreference_SeatList, GalileoBookingProp, EmailBookingProperties, PassengerMealBaggageProperties, MealAirArabiaProperties, AssociatedAdultwithInfantList } from '../Models/BookingPassengerTicketIssuanceProperties';
import { Countries } from '../Models/Countries';
import { ContactUsComponentServicesService } from '../Services/contactus.service';
import { NgSelectModule, NgSelectComponent, NgSelectConfig, NgOption } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import * as $ from "jquery";
import { any } from 'codelyzer/util/function';
import { formatDate, DatePipe, AsyncPipe, DecimalPipe } from '@angular/common';
import { locale } from 'devextreme/localization';
import { BookingBasicProperties, AirSegmentsDetails, FlightSearchProperties, PriceCardDetails, FlightSearchDestinationProperties, ModifyFlightAirAiternary, SpiceOldCancelDetails, SpiceNewModifyDetails, AljazeerafronuseSupplierPricingSolution } from '../Models/FlightSearchProperties';
import { AirItinerary, AirPricingSolution, typeBaseAirSegment } from '../Models/AirPricingSolutionProperties';
import { ModalDismissReasons, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { PassengerProfile } from '../Models/BookingPassengerTicketIssuanceProperties';
import { DxDataGridComponent } from 'devextreme-angular';
import { BaseFlightDetails, PassengerFares, Seatobject, Ssr, AljazeeraSSRResponse, modifyFlights, ChangeRBDParamsGalileo } from '../Models/FlightSearchResponseProperties';
import { SpiceProperties, SpiceSSR, SpiceSeat } from '../Models/spice-properties';
import { Local } from 'protractor/built/driverProviders';
import { AuthService } from '../Services/auth.service';
import { MessageService, PrimeTemplate } from 'primeng/api';
import { FlightSearchService } from '../Services/FlightSearch.service';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Dialog } from 'primeng/dialog';



@Component({
    selector: 'app-spice-modification',
    templateUrl: './spice-modification.component.html',
    styleUrls: ['./spice-modification.component.css'],
    imports: [NavMenuComponent, FormsModule, Bind, Dialog, PrimeTemplate, RouterLink, AsyncPipe, DecimalPipe]
})

export class SpiceModificationComponent implements OnInit {
  baseServicesData: any;
  closeResult: string;
  fzAnxii: boolean;
  airIndiaWithBaggage: boolean;
    buttonagreed: boolean;
    anciService: boolean;
  mealListJ: any[];
  mealPersonIndex: number;
    mealerror: boolean;
  mealSectorIndex: number;
  mealListIndex: number;
    baggageerror: boolean;
  bagPersonIndex: number;
  baglSectorIndex: number;
  bagListIndex: number;
  passngerIndex: number;
  sectorIndex: number;
  seatIndex: number;

  constructor(private messageService: MessageService, private authservice: AuthService, private flightservice: FlightSearchService, private NewSuccess: NgbModal, private FallSuccess: NgbModal, public userService: PassengerInfoService, public contactUsService: ContactUsComponentServicesService, private http: HttpClient, private router: Router, private modalService: NgbModal) {
    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg' as any
    }
  }
  modalOptions: NgbModalOptions;
  passengerInfoObj = new BookingPassengerInfoProperties();
  sectorObj = new SectorInformationProperties();
  taxObj = new TaxDetailsProperties();
  obj = new BookingPassengerInfoProperties();
  bookingObj = new BookingInfoProperties();
  personalInfoList: BookingPassengerInfoProperties[] = [];
  bookingInfoList: BookingPassengerInfoProperties[] = [];
  countryList: Countries[] = [];
  responseObj = new PassengerCreationResponse();
  bookingBaseData = new BookingBasicProperties();
  flightSearchDestList: FlightSearchDestinationProperties[] = [];
  emailRegex: boolean = false;
  email: string = "";
  mobile: string = "";
  phone: string = "";
  extraprofit: number = 0;
  countryCodeList = [];
  infantAge = "Less Than 2 years";
  childAge = "Less Than 12 years";
  adultAge = "18 years or Above";
  priceCardDetails: PriceCardDetails[] = [];
  totalBasePrice: number = 0;
  currency: string = "";
  currencyRate: number = 0;
  currencyRateJ: number = 0;

  totalTaxes: number = 0;

  totalPrice: number = 0;

  totalBasePriceConv: string = "";

  totalTaxesConv: string = "";
  totalANCIConv: string = "";
  seatListJazeera: Seatobject[] = [];
  baggageListJ: Ssr[] = [];
  ssrJazeera = new AljazeeraSSRResponse();
  J9Anxi: boolean = false;
  seatListSpice: SpiceSeat[] = [];
  ssrSpice = new SpiceSSR();
  SpiceAnxi: boolean = false;

  dueDate: Date = new Date();
  totalPriceConv: string = "";
  totalServiceFee: number = 0;
  totalDiscount: number = 0;
  totalServiceFeeConv: string = "";
  totalDiscountConv: string = "";
  book: boolean = false;
  agencyid: string = "";
  visibleWrongAgency: boolean = false;
  /*numberOfForms =(localStorage.getItem("formNumbers"))*/;
  BookingProperties = new BookingInfoProperties();
  AdultC = 0;
  InfantC = 0;
  ChildC = 0;
  Adultbasefare = 0;
  Childbasefare = 0;
  Infantbasefare = 0;
  Adultservicecharges = 0;
  Childservicecharges = 0;
  Infantservicecharges = 0;
  Adulttax = 0;
  Childtax = 0;
  Infanttax = 0;
  TotalAdulttax = 0;
  TotalChildtax = 0;
  TotalInfanttax = 0;
  serviceChargesPNR: number = 0;
  oldserviceChargesPNR: number = 0;
  bookingPassengerFareDetails: BookingPassengerInfoProperties[] = [];;
  showServiceCharges: boolean = false;
  counterForms = [{ numbers: 1, type: "Adult" }, { numbers: 1, type: "Children" }, { numbers: 0, type: "Infant" }];

  preferences: any;
  passengermealobj = new PassengerMealBaggageProperties();
  airarbiaWithBaggage: boolean = false;
  mealAirArabiaList = new MealAirArabiaProperties();
  airarabialoader: boolean;
  bookingLoader: boolean;
  airsialpaskistan: boolean = false;
  withanimationoption: number = 0;
  modifyFlight = new ModifyFlightAirAiternary();
  spiceOldCancelDetails = new SpiceOldCancelDetails;
  spiceNewModifyDetails = new SpiceNewModifyDetails;
  balanceDue: number = 0;
  taxesModifyDeduction: number = 0;
  totalCostModified: number = 0;
  AmountPaid: number = 0;
  ngOnInit() {

    /*ngOnInit(){*/
    const bookingdata = localStorage.getItem('bkdata');

    if (!bookingdata) {
      this.router.navigateByUrl("/flightSearch");
      return;
    }

    this.bookingBaseData = JSON.parse(bookingdata);
    this.modifyFlight = JSON.parse(this.bookingBaseData.modifyFlight);
    this.spiceOldCancelDetails = JSON.parse(this.modifyFlight.oldCancelDetails);
    this.spiceNewModifyDetails = JSON.parse(this.modifyFlight.newModifyDetails);
    this.agencyid = localStorage.getItem("AgencyId");
    this.bookingObj = this.modifyFlight.bookingInfo;
    //this.agencyid = localStorage.getItem("AgencyId");
    if (this.agencyid.includes("AG01"))
      this.showServiceCharges = true;
    /*}*/
    this.bookingObj.providerCode = this.bookingBaseData.supplierCode;
    if (this.bookingBaseData != null && this.bookingBaseData != undefined) {
      if (this.bookingBaseData.airSegment.length > this.bookingBaseData.flightProp.flightLocationInfo.length) {
        this.bookingBaseData.stopcount = 1;
      }
      this.getCountries();
      //this.getServiceType();
      //this.getMealList();
      //this.getSeatList();
      this.getFlyerCountry();

      if (this.bookingBaseData.flightProp.infant <= 0) {
        $(".infant_type").hide();
      }
      if (this.bookingBaseData.flightProp.child <= 0) {
        $(".child_type").hide();
      }
      if (this.bookingBaseData.flightProp.adult <= 0) {
        $(".adult_type").hide();
      }
      //for (let i = 0; i < this.bookingBaseData.flightProp.adult; i++) {
      //  this.obj.passengerType = 1;
      //  let date = Date.now();
      //  let dateStr = String(date);
      //  let slicedDate = dateStr.slice(7);
      //  let PAX = 1;
      //  this.obj.passengerID = Number(slicedDate + PAX + i);
      //  this.obj.sectorInformationProperties.push(this.sectorObj);
      //  this.obj.taxDetailsProperties.push(this.taxObj);

      //  this.bookingObj.bookingPassengerInfoProperties.push(this.obj);
      //  this.sectorObj = new SectorInformationProperties();
      //  this.taxObj = new TaxDetailsProperties();
      //  this.obj = new BookingPassengerInfoProperties();
      //}
      //for (let i = 0; i < this.bookingBaseData.flightProp.child; i++) {
      //  this.obj.passengerType = 2; //
      //  let date = Date.now();
      //  let dateStr = String(date);
      //  let slicedDate = dateStr.slice(7);
      //  let PAX = 2;
      //  this.obj.passengerID = Number(slicedDate + PAX + i);
      //  this.obj.sectorInformationProperties.push(this.sectorObj);
      //  this.obj.taxDetailsProperties.push(this.taxObj);
      //  this.bookingObj.bookingPassengerInfoProperties.push(this.obj);
      //  this.sectorObj = new SectorInformationProperties();
      //  this.taxObj = new TaxDetailsProperties();
      //  this.obj = new BookingPassengerInfoProperties();
      //}
      //for (let i = 0; i < this.bookingBaseData.flightProp.infant; i++) {
      //  this.obj.passengerType = 3; //
      //  let date = Date.now();
      //  let dateStr = String(date);
      //  let slicedDate = dateStr.slice(7);
      //  let PAX = 3;
      //  this.obj.passengerID = Number(slicedDate + PAX + i);
      //  this.obj.sectorInformationProperties.push(this.sectorObj);
      //  this.obj.taxDetailsProperties.push(this.taxObj);
      //  this.bookingObj.bookingPassengerInfoProperties.push(this.obj);
      //  this.sectorObj = new SectorInformationProperties();
      //  this.taxObj = new TaxDetailsProperties();
      //  this.obj = new BookingPassengerInfoProperties();

      //}


      this.userService.CheckAgentBookRightAgainstAgencyAndUserId(localStorage.getItem("UserId"), localStorage.getItem("AgencyId")).subscribe((data2) => {
        //  for (let i = 0; i < this.flightDataCarry.length; i++) {
        //console.log(data2);
        if (data2.bookingAgency && data2.bookingUser) {
          this.book = true;
        }
        else if (data2.bookingAgency && data2.bookingUser) { }
        else {
          this.book = false;
        }


        //}
      });
      if (this.bookingBaseData.flightscheduleNew != null) {

        this.bookingObj.currencyCriteriaThatApplied = this.bookingBaseData.flightscheduleNew.currencyCriteriaThatApplied;
        this.bookingObj.currencyRateByDefault = this.bookingBaseData.flightscheduleNew.currencyRateByDefault;
        this.bookingObj.revenueApplied = this.bookingBaseData.flightscheduleNew.revenueApplied;

      }
      for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {
        this.bookingObj.bookingPassengerInfoProperties[j].bookingPccCode = this.bookingBaseData.bookingPCC;

      }
     if (this.bookingBaseData.supplierCode == "SG") {
        this.spiceAnxillaryProcessing();
      } 

      this.ProcessSegments();
      this.getAirports();

    }
    else {
      let userid = 0;
      userid = Number(localStorage.getItem("UserId"));
      if (userid > 0 && userid != null && userid != undefined) {
        this.router.navigateByUrl('/flightSearch');
      }
      else {
        window.localStorage.setItem('logout-event', Math.random().toString())
        this.authservice.logOut();
      }

    }



  }
  ngOnDestroy() {
    localStorage.removeItem('bkdata');
  }
  agreed: boolean;
  active() {
    if (this.agreed == true) {
      $(".sendButton").css({ "pointer-events": "auto", "opacity": 1 });
    }
    else {
      $(".sendButton").css({ "pointer-events": "none", "opacity": 0.6 });
    }
  }




  dobDifference: number;
  isDOBVarified: boolean;
  isIssuanceValidated: boolean;
  isExpiryValidated: boolean;
  issuanceDifference: number;
  expiryDifference: number;


  dobValidation(dobvalue, pstypedob) {
    /*for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {*/
    /* var dobDatePax = document.getElementById(`dob_input${j}`) as HTMLInputElement;*/
    let currentDate: Date = new Date();
    let dob: Date = new Date(dobvalue);
    this.dobDifference = currentDate.getMonth() - dob.getMonth() +
      (12 * (currentDate.getFullYear() - dob.getFullYear()));

    if (this.dobDifference >= 144 && this.dobDifference < 1200 && pstypedob == 1) {
      this.isDOBVarified = true;
      // console.log("Adult Age Varified" + this.dobDifference);
    }
    else if (this.dobDifference >= 24 && this.dobDifference < 144 && pstypedob == 2) {
      this.isDOBVarified = true;
      // console.log("Child Age Varified" + this.dobDifference);
    }
    else if (this.dobDifference > 0 && this.dobDifference < 24 && pstypedob == 3) {
      //alert("Infant is Over Aged..Must be less than 2 years of age.");
      this.isDOBVarified = true;
      //console.log("Infant Age Varified...!" + this.dobDifference);
    }

    else if (this.dobDifference < 0) {
      //alert("Enter a valid date of birth.");
      this.isDOBVarified = false;
      return this.isDOBVarified;
    }
    else if (this.dobDifference > 1200) {
      // alert("How can you live that long???");
      this.isDOBVarified = false;
      return this.isDOBVarified;
    }
    else {
      //alert("Age not met to conditions!");
      this.isDOBVarified = false;
      return this.isDOBVarified;
    }

    /*    }*/

    return this.isDOBVarified;
  }

  ApplyServiceCharges() {



    for (let i = 0; i < this.priceCardDetails.length; i++) {
      let bagfee = (Number(this.priceCardDetails[i].baggageFee.substring(3)));
      let seatfee = (Number(this.priceCardDetails[i].seatFee.substring(3)));
      let mealfee = (Number(this.priceCardDetails[i].mealFee.substring(3)));
      let servicefeenew = (this.priceCardDetails[i].passengerCount * this.serviceChargesPNR);
      let servicefeeold = (this.priceCardDetails[i].passengerCount * this.oldserviceChargesPNR);
      this.priceCardDetails[i].serviceFee = this.currency + (Number(this.priceCardDetails[i].agencyServiceFee.substring(3)) + servicefeenew - servicefeeold);
      this.priceCardDetails[i].agencyServiceFee = this.currency + (Number(this.priceCardDetails[i].agencyServiceFee.substring(3)) + servicefeenew - servicefeeold);
      this.priceCardDetails[i].agencyTotalPrice = this.currency + (Number(this.priceCardDetails[i].agencyTotalPrice.substring(3)) + servicefeenew - servicefeeold);
      this.totalPrice += (servicefeenew - servicefeeold) + bagfee + seatfee + mealfee;
    }
    this.totalPriceConv = this.currency + this.totalPrice.toFixed(2);
    this.totalDiscountConv = this.currency + this.totalDiscount.toFixed(2);

    this.totalServiceFeeConv = this.currency + this.totalServiceFee.toFixed(2);
    this.bookingObj.extraServiceCharges = this.serviceChargesPNR;
    this.oldserviceChargesPNR = this.serviceChargesPNR;
  }


  ProcessSegments() {

    //if (this.bookingBaseData.supplierCode == "1G") {

    //let airItienary: AirItinerary;

    //let airItienary: BookingBasicProperties;

    let flightProp: FlightSearchProperties;

    //airItienary = this.bookingBaseData.airItienary;

    flightProp = this.bookingBaseData.flightProp;

    //console.log(airSegment);





    let airPricingSolution: PassengerFares[] = [];

    airPricingSolution = this.bookingBaseData.passengerFares;

    let completeprofit = 0;

    if (this.bookingBaseData.extraProfit == undefined)

      this.bookingBaseData.extraProfit = 0;

    //for (let i = 0; i < airPricingSolution.airPricingInfo.length; i++) {
    //this.currency = airPricingSolution[0].totalAmount.substring(0, 3);
    this.currency = airPricingSolution[0].agencyBaseFareAmount.substring(0, 3);
    this.currencyRate = this.bookingBaseData.flightscheduleNew.currencyRateByDefault;
    this.currencyRateJ = airPricingSolution[0].jazCRate;
    for (let i = 0; i < airPricingSolution.length; i++) {

      //for (let j = 0; j < airPricingSolution.airPricingInfo[i].passengerType.length; j++) {

      let priceCard = new PriceCardDetails();

      priceCard.passengerType = String(airPricingSolution[i].passengerType);



      //let

      if (priceCard.passengerType == "1") {

        priceCard.passengerType = "Adult";

        this.extraprofit = this.bookingBaseData.extraProfit *

          (this.bookingBaseData.flightProp.adult);

        priceCard.passengerCount = airPricingSolution[i].count;

      }

      else if (priceCard.passengerType == "2") {

        priceCard.passengerType = "Child";

        this.extraprofit = this.bookingBaseData.extraProfit *

          (this.bookingBaseData.flightProp.child);

        priceCard.passengerCount = airPricingSolution[i].count;

      }

      else if (priceCard.passengerType == "3") {

        priceCard.passengerType = "Infant";

        this.extraprofit = this.bookingBaseData.extraProfit *

          (this.bookingBaseData.flightProp.infant);

        priceCard.passengerCount = airPricingSolution[i].count;

      }
      if ((this.bookingBaseData.supplierCode == "1G" || this.bookingBaseData.supplierCode == "6E" || this.bookingBaseData.supplierCode == "PA" || this.bookingBaseData.supplierCode == "G9" || this.bookingBaseData.supplierCode == "9P" || this.bookingBaseData.supplierCode == "ONEAPI" || this.bookingBaseData.supplierCode == "3L") && flightProp.tripType == "multi") {
        priceCard.indivisualBasePrice = airPricingSolution[i].baseFareAmount;
        priceCard.agencyBasePrice = airPricingSolution[i].agencyBaseFareAmount;
        priceCard.indivisualTaxes = this.currency + (Number(airPricingSolution[i].taxAmount.substring(3)) + this.extraprofit).toFixed(2);
        priceCard.agencyTaxes = airPricingSolution[i].agencyTaxAmount;
        priceCard.indivisualTotalPrice = this.currency + (Number(airPricingSolution[i].totalAmount.substring(3)) + this.extraprofit).toFixed(2);
        priceCard.agencyTotalPrice = this.currency + (Number(airPricingSolution[i].agencyTotalPrice.substring(3)) + this.extraprofit).toFixed(2);
        priceCard.serviceFee = airPricingSolution[i].serviceFee;
        priceCard.agencyServiceFee = airPricingSolution[i].agencyServiceFee;
        priceCard.discount = airPricingSolution[i].discount;
        priceCard.agencyDiscount = airPricingSolution[i].agencyDiscount;
        priceCard.currencyRate = this.currencyRate;
        priceCard.jazCRate = this.currencyRateJ;
        priceCard.seatFee = this.currency + "0";
        priceCard.mealFee = this.currency + "0";
        priceCard.baggageFee = this.currency + "0";
        this.totalANCIConv = this.currency + "0";
      }
      else {
        priceCard.indivisualBasePrice = airPricingSolution[i].baseFareAmount;
        priceCard.agencyBasePrice = airPricingSolution[i].agencyBaseFareAmount;
        priceCard.indivisualTaxes = this.currency + (Number(airPricingSolution[i].taxAmount.substring(3))).toFixed(2);
        if (this.bookingBaseData.groupTicketId > 0) {
          priceCard.agencyTaxes = this.currency + (Number(airPricingSolution[i].agencyTaxAmount.substring(3)) + Number(airPricingSolution[i].gruoupTicketServiceCharges.substring(3)));
        }
        else {
          priceCard.agencyTaxes = airPricingSolution[i].agencyTaxAmount;

        }
        priceCard.indivisualTotalPrice = airPricingSolution[i].totalAmount;
        priceCard.agencyTotalPrice = airPricingSolution[i].agencyTotalPrice;
        priceCard.serviceFee = airPricingSolution[i].serviceFee;
        priceCard.agencyServiceFee = airPricingSolution[i].agencyServiceFee;
        priceCard.discount = airPricingSolution[i].discount;
        priceCard.agencyDiscount = airPricingSolution[i].agencyDiscount;
        priceCard.currencyRate = this.currencyRate;
        priceCard.jazCRate = this.currencyRateJ;
        priceCard.seatFee = this.currency + "0";
        priceCard.mealFee = this.currency + "0";
        priceCard.baggageFee = this.currency + "0";
        this.totalANCIConv = this.currency + "0";
      }



      completeprofit += this.extraprofit;

      //this.totalBasePrice += Number(airPricingSolution[i].baseFareAmount.substring(3));
      //this.totalServiceFee += Number(airPricingSolution[i].serviceFee.substring(3));
      //this.totalDiscount += Number(airPricingSolution[i].discount.substring(3));
      //this.totalTaxes += (Number(airPricingSolution[i].taxAmount.substring(3)));
      //this.totalPrice += (Number(airPricingSolution[i].totalAmount.substring(3)));
      this.totalBasePrice += Number(airPricingSolution[i].agencyBaseFareAmount.substring(3));
      this.totalServiceFee += Number(airPricingSolution[i].agencyServiceFee.substring(3));
      if (airPricingSolution[i].agencyDiscount != null && airPricingSolution[i].agencyDiscount != undefined) {
        this.totalDiscount += Number(airPricingSolution[i].agencyDiscount.substring(3));
      }
      else {
        this.totalDiscount = 0
      }



      if ((this.bookingBaseData.supplierCode == "1G" || this.bookingBaseData.supplierCode == "6E" || this.bookingBaseData.supplierCode == "G9" || this.bookingBaseData.supplierCode == "PA" || this.bookingBaseData.supplierCode == "9P" || this.bookingBaseData.supplierCode == "ONEAPI" || this.bookingBaseData.supplierCode == "3L") && flightProp.tripType == "multi") {

        this.totalTaxes += (Number(airPricingSolution[i].agencyTaxAmount.substring(3)) + this.extraprofit);
        this.totalPrice += (Number(airPricingSolution[i].agencyTotalPrice.substring(3)) + this.extraprofit);
      }
      else {

        if (this.bookingBaseData.groupTicketId > 0) {
          this.totalTaxes += ((Number(airPricingSolution[i].agencyTaxAmount.substring(3))) + (Number(airPricingSolution[i].gruoupTicketServiceCharges.substring(3))));
        }
        else {
          this.totalTaxes += (Number(airPricingSolution[i].agencyTaxAmount.substring(3)));

        }



        this.totalPrice += (Number(airPricingSolution[i].agencyTotalPrice.substring(3)));
      }
      this.priceCardDetails.push(priceCard);







      //priceCard.indivisualBasePrice = airPricingSolution[i].baseFareAmount;
      //priceCard.indivisualTaxes = this.currency + (Number(airPricingSolution[i].taxAmount.substring(3)));
      //priceCard.indivisualTotalPrice = airPricingSolution[i].totalAmount;
      //priceCard.serviceFee = airPricingSolution[i].serviceFee;
      //priceCard.discount = airPricingSolution[i].discount;
      //priceCard.seatFee = this.currency + "0";
      //priceCard.mealFee = this.currency + "0";
      //priceCard.baggageFee = this.currency + "0";

      //completeprofit += this.extraprofit;

      //this.totalBasePrice += Number(airPricingSolution[i].baseFareAmount.substring(3));
      //this.totalServiceFee += Number(airPricingSolution[i].serviceFee.substring(3));
      //this.totalDiscount += Number(airPricingSolution[i].discount.substring(3));
      //this.totalTaxes += (Number(airPricingSolution[i].taxAmount.substring(3)));
      //this.totalPrice += (Number(airPricingSolution[i].totalAmount.substring(3)));
      //this.priceCardDetails.push(priceCard);

      //}



    }    //}


    this.totalBasePriceConv = this.currency + this.totalBasePrice.toFixed(2);

    this.totalTaxesConv = this.currency + this.totalTaxes.toFixed(2);

    this.totalPriceConv = this.currency + this.totalPrice.toFixed(2);
    this.totalDiscountConv = this.currency + this.totalDiscount.toFixed(2);

    this.totalServiceFeeConv = this.currency + this.totalServiceFee.toFixed(2);

    this.balanceDue = Number(this.spiceNewModifyDetails.NewBalanceDue.toFixed(2));
    let taxesDeducted = this.spiceNewModifyDetails.NewTotalCost - this.spiceOldCancelDetails.OldTotalCost - this.totalPrice;
    this.taxesModifyDeduction = Number((taxesDeducted + this.spiceOldCancelDetails.OldBalanceDue).toFixed(2));
    this.totalCostModified = this.spiceNewModifyDetails.NewTotalCost;

    if (this.spiceOldCancelDetails.OldBalanceDue > 0) {
      this.AmountPaid = Number(this.spiceNewModifyDetails.NewBalanceDue.toFixed(2));
    } else {
      this.AmountPaid = Number(this.spiceNewModifyDetails.NewBalanceDue.toFixed(2));
    }

  }

  airportList: FlightSearchDestinationProperties[] = [];
  airportObj = new FlightSearchDestinationProperties();
  citiesCodes: string[];
  getAirports() {
    this.citiesCodes = [];
    for (let i = 0; i < this.bookingBaseData.airSegment.length; i++) {

      this.airportObj.fromCity = this.bookingBaseData.airSegment[i].origin.code;
      this.airportObj.toCity = this.bookingBaseData.airSegment[i].destination.code;
      this.citiesCodes.push(this.airportObj.fromCity);
      this.citiesCodes.push(this.airportObj.toCity);
    }
    this.userService.getAirportsByCode(this.citiesCodes).subscribe((data) => {
      if (this.bookingBaseData.airSegment.length > 0) {
        this.flightSearchDestList = data;
        for (let i = 0; i < this.bookingBaseData.airSegment.length; i++) {
          for (let j = 0; j < this.flightSearchDestList.length; j++) {
            let city: string = "";
            city = this.flightSearchDestList[j].viaAirport.split('-')[0].trim();
            if (this.bookingBaseData.airSegment[i].origin.code === city) {
              this.bookingBaseData.airSegment[i].origin.airportName = this.flightSearchDestList[j].viaAirport;

            }
            if (this.bookingBaseData.airSegment[i].destination.code === city) {
              this.bookingBaseData.airSegment[i].destination.airportName = this.flightSearchDestList[j].viaAirport;
            }

          }

        }
      }
    })
  }

  selectedValue: number;
  show_List: boolean;
  serviceTypeList: TravelPreference_ServiceType[] = [];
  mealListShow: TravelPreference_MealList[] = [];
  seatListShow: TravelPreference_SeatList[] = [];
  emptyList = [];
  changeServiceType(value: number) {
    try {
      this.selectedValue = value;

    }
    catch (e) {
      console.log(e);
    }
  }

  appliesToList = [];

  getCountries() {
    try {
      this.userService.getCountries().subscribe((data) => {
        this.countryList = data;

      });
    }
    catch (e) {
      console.log(e);
    }
  }

  
  getFlyerCountry() {
    this.countryCodeList.push(this.sectorObj.fromAirport);
    this.countryCodeList.push(this.sectorObj.stopsAt);
    this.countryCodeList.push(this.sectorObj.toAirport);
  }
 

  bookingID: number;

  setBookingID(bookingID: number) {
    try {
      localStorage.setItem('bookingID', bookingID.toString());
      this.router.navigateByUrl('/ticket-issuance');
    }
    catch (e) {
      console.log(e);
    }
  }

  //contactsAssignment() {
  //  for (let i = 0; i < this.bookingObj.bookingPassengerInfoProperties.length; i++) {
  //    this.bookingObj.bookingPassengerInfoProperties[i].mobile = this.mobile;
  //    this.bookingObj.bookingPassengerInfoProperties[i].phone = this.phone;
  //    this.bookingObj.bookingPassengerInfoProperties[i].email = this.email;
  //  }
  //}
  RequiredInput = true;
  RequiredValidation(i) {

  }


  onSubmit() {
    this.bookingObj.flightSchedule = this.bookingBaseData.flightscheduleNew;
    this.bookingObj.currencyRateByDefault = this.bookingBaseData.flightscheduleNew.currencyRateByDefault;
    this.bookingObj.currencyCriteriaThatApplied = this.bookingBaseData.flightscheduleNew.currencyCriteriaThatApplied;
    this.bookingObj.revenueApplied = this.bookingBaseData.flightscheduleNew.revenueApplied;
    this.NewSuccess.dismissAll();
    //return;
    this.buttonagreed = true;
    this.bookingObj.galileoBookingProp = new GalileoBookingProp();
    this.bookingObj.finalBuyerID = localStorage.getItem("AgencyId");
    this.bookingObj.creationUser = Number(localStorage.getItem("UserId"));
    this.bookingObj.extraMarkup = this.bookingBaseData.extraProfit;
    this.bookingObj.galileoBookingProp.flightProp = new FlightSearchProperties();
    this.bookingObj.galileoBookingProp.flightProp = this.bookingBaseData.flightProp;
    this.bookingObj.galileoBookingProp.airSegments = this.bookingBaseData.airSegment;
    this.bookingObj.galileoBookingProp.priceCardDetails = this.priceCardDetails;
    this.bookingObj.providerCode = this.bookingBaseData.supplierCode;
    this.bookingObj.passengerFares = this.bookingBaseData.passengerFares;
    this.bookingObj.supplierAirPricingSolution = this.bookingBaseData.supplierPricingSolution;
    this.bookingObj.galileoBookingProp.supplier = this.bookingBaseData.supplierCode;
    this.bookingObj.anciSelected = this.anciService;
    this.buttonagreed = true;


    if (this.bookingBaseData.supplierCode == "SG") {
      this.bookingObj.transactionIdentifierJ = this.bookingBaseData.transactionIdentifierJ;
      this.bookingObj.totalAmount = Number(this.totalPriceConv.slice(3));
      this.bookingObj.SpicePaidAmount = this.AmountPaid;


    }
    this.bookingObj.dueDate = this.dueDate;

    {
      let modify = new ModifyFlightAirAiternary();
      modify.bookingInfo = this.bookingObj;
      modify.rbdParam = new ChangeRBDParamsGalileo();
      modify.rbdParam.bookingPCC = this.bookingObj.bookingPassengerInfoProperties[0].bookingPccCode;
      modify.rbdParam.supplier = "SG";
      this.airarabialoader = true;
      this.flightservice.ModifyBooking(modify).subscribe((data) => {
        this.airarabialoader = false;
        if (data == null) {
          this.buttonagreed = false;
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=red>Error occurred while Booking creation..</font>"
          $("#response-screen").delay(7000).hide(1000);
          return;
        }
        if (data.isSaved) {
          localStorage.setItem("bookingID", String(data.bookingID));
          this.router.navigateByUrl('/ticket-issuance');
        }

      })
    }

  }

  dismis() {
    $(".notification_area").hide(300);
  }
  cancel() {
    //this.obj = new BookingPassengerInfoProperties();
    this.bookingObj = new BookingInfoProperties();
  }


  getBookingServicesBaseData() {
    try {
      this.userService.getAllBookingServicesData().subscribe((data) => {
        this.baseServicesData = data;
        this.serviceTypeList = this.baseServicesData.serviceType;
        this.mealListShow = this.baseServicesData.mealList;
        this.seatListShow = this.baseServicesData.seatList;
      });
    }
    catch (e) {
      console.log(e);
    }
  }

  open(content) {
    this.modalService.open(content, this.modalOptions).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  back(): void {
    this.router.navigateByUrl('/flightResults');
  }







  tktSuccuessPopup(targetmodel) {

    if (this.bookingBaseData.supplierCode == '6E') {
      var date = new Date();
      date.setDate(date.getDate() + 3);
      var departuredate = new Date(this.bookingBaseData.airSegment[0].originalDepartureDate)

      if (departuredate <= date) {
        this.NewSuccess.open(targetmodel, {

          /* windowClass: "searchpassengerpopupmodal"*/
          windowClass: "warningPopupmodal", centered: true
        })
      }
      else {


        let agencyId = "";
        agencyId = localStorage.getItem("AgencyId")
        if (agencyId == this.agencyid) {
          this.onSubmit();
        }
        else {
          this.visibleWrongAgency = true;
        }


      }
    }
    else {


      let agencyId = "";
      agencyId = localStorage.getItem("AgencyId")
      if (agencyId == this.agencyid) {
        this.onSubmit();
      }
      else {
        this.visibleWrongAgency = true;
      }


    }

  }
  baggageclose(i, z) {

    document.getElementById(`baggagepopup${i}${z}`).classList.add("numofseatmodel");

  }
  
  SpiceDirect: boolean = false;
  SpiceViaT: boolean = false;
  SpiceConnecting: boolean = false;
  DepartureInformationProperties: SectorInformationProperties[] = [];
  ReturnInformationProperties: SectorInformationProperties[] = [];
  SpiceRDirect: boolean = false;
  SpiceRViaT: boolean = false;
  SpiceRConnecting: boolean = false;
  spiceAnxillaryProcessing() {
    this.SpiceAnxi = true;
    let supsolfront = new AljazeerafronuseSupplierPricingSolution();
    supsolfront = JSON.parse(this.bookingBaseData.flightscheduleNew.frontReusePricingSolution);
    this.ssrSpice = JSON.parse(supsolfront.jazeeraAnxi);
    this.seatListSpice = JSON.parse(supsolfront.jazeeraSeats);



    for (let j = 0; j < this.bookingObj.bookingPassengerInfoProperties.length; j++) {//main loop


      for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport = this.bookingBaseData.airSegment[z].origin.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport = this.bookingBaseData.airSegment[z].destination.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureDate = this.bookingBaseData.airSegment[z].originalDepartureDate;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalDate = this.bookingBaseData.airSegment[z].originalArrivalDate;

        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].airlineCode = this.bookingBaseData.airSegment[z].carrier;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].flightNumber = this.bookingBaseData.airSegment[z].flightNumber;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirportName = this.bookingBaseData.airSegment[z].origin.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirportName = this.bookingBaseData.airSegment[z].destination.code;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].departureTerminal = this.bookingBaseData.airSegment[z].origin.terminal;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].arrivalTerminal = this.bookingBaseData.airSegment[z].destination.terminal;
        this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].noOfStops = this.bookingBaseData.stopcount;
      }



      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length == 1) {
          this.SpiceDirect = true;
          if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
            for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
              if (this.ssrSpice != null) {
                if (this.SpiceDirect == true) {
                  for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {

                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                    }
                  }
                }
              }
              if (this.seatListSpice != null) {
                for (let y = 0; y < this.seatListSpice.length; y++) {
                  if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length == 1) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatbtn = true;
                    }
                  }
                  //} else if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length > 1) {
                  //  if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
                  //    && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[1].ArrivalStation) {

                  //    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                  //  }
                  //}
                }
              }
            }
          }

        } else if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 1) {

          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].flightNumber ==
            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[1].flightNumber) {
            this.SpiceViaT = true;
          } else {
            this.SpiceConnecting = true;
          }

          if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
            for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

              if (this.ssrSpice != null) {

                if (this.SpiceViaT == true) {
                  //meal on first leg.....baggage and infant on entire journey
                  for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z + 1].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].baggagebtn = true;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].mealbtn = true;
                      break;
                    }
                  }

                  if (this.seatListSpice != null) {

                    for (let y = 0; y < this.seatListSpice.length; y++) {
                      for (let d = 0; d < this.seatListSpice[y].SeatAvailabilityResponse.Legs.length; d++) {
                        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[d].DepartureStation
                          && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[d].ArrivalStation) {
                          //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
                          //  return (ele.availability != null || ele.availability == "0");
                          //})
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].seatbtn = true;
                          //break;
                        }
                      }
                    }
                  }

                }
                //}

                //if (this.ssrSpice != null) {
                if (this.SpiceConnecting == true) {
                  //meal on first leg.....baggage and infant on both segments
                  for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].baggagebtn = true;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].mealbtn = true;
                      break;
                    }
                  }

                  if (this.seatListSpice != null) {

                    for (let y = 0; y < this.seatListSpice.length; y++) {
                      for (let d = 0; d < this.seatListSpice[y].SeatAvailabilityResponse.Legs.length; d++) {
                        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[d].DepartureStation
                          && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[d].ArrivalStation) {
                          //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
                          //  return (ele.availability != null || ele.availability == "0");
                          //})
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatbtn = true;
                          //break;
                        }
                      }
                    }
                  }
                }
              }

            }
          }


        }
      }
      else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length == 2) {
          for (let c = 0; c < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; c++) {

            if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport &&
              this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
              //departure segments
              this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              this.SpiceDirect = true;
            }
            if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport &&
              this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
              //return segments
              this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              this.SpiceRDirect = true;
            }
          }
          //direct
          ///////////////////////////////////////////////////////
          if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
            for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
              if (this.ssrSpice != null) {
                if (this.SpiceDirect == true) {
                  for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation
                      && this.DepartureInformationProperties[0].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.DepartureInformationProperties[0].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {

                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;

                    }
                  }
                }
                if (this.SpiceRDirect == true) {
                  for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation
                      && this.ReturnInformationProperties[0].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                      && this.ReturnInformationProperties[0].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {

                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;

                    }
                  }
                }
              }
              if (this.seatListSpice != null) {
                for (let y = 0; y < this.seatListSpice.length; y++) {
                  if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length == 1) {
                    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
                      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
                      //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
                      //  return (ele.availability != null || ele.availability == "0");
                      //})
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatbtn = true;
                      //break;
                    }
                  }
                }
              }
            }
          }



        } else if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 2) {
          if (j == 0) {
            for (let c = 0; c < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; c++) {

              if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport &&
                this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
                //departure segments
                this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              } else if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport) {
                //departure segments
                this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              } else if (this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
                //departure segments
                this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              }


              if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport &&
                this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
                //return segments
                this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              } else if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport) {
                //return segments
                this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              } else if (this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
                //return segments
                this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
              }


            }
          }
        }

      }

      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2 && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 2) {

        for (let q = 0; q < this.DepartureInformationProperties.length; q++) {
          if (this.DepartureInformationProperties.length > 1) {
            if (this.DepartureInformationProperties[0].flightNumber == this.DepartureInformationProperties[1].flightNumber) {
              this.SpiceViaT = true;
            } else {
              this.SpiceConnecting = true;
            }
          } else {
            this.SpiceDirect = true;
          }
        }

        for (let q = 0; q < this.ReturnInformationProperties.length; q++) {
          if (this.ReturnInformationProperties.length > 1) {
            if (this.ReturnInformationProperties[0].flightNumber == this.ReturnInformationProperties[1].flightNumber) {
              this.SpiceRViaT = true;
            } else {
              this.SpiceRConnecting = true;
            }
          } else {
            this.SpiceRDirect = true
          }
        }


        //////////////////////////////////////////////////////////
        let viaCount = 0;
        let rviaCount = 0;
        let connectCount = 0;
        let rconnectCount = 0;
        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 2) {

          if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {
            for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {
              if (this.ssrSpice != null) {
                if (this.SpiceViaT == true || this.SpiceRViaT == true || this.SpiceDirect == true) {

                  if (this.DepartureInformationProperties.length == 1) {

                    if (this.SpiceViaT == true && z + 1 <= this.DepartureInformationProperties.length) {

                      let depindex = 0;
                      for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList.length; cb++) {
                        if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                          depindex = cb;
                          break;
                        }
                      }
                      //meal on first leg.....baggage and infant on entire journey
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depindex].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depindex].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depindex].SSRLegList[h].LegKey.ArrivalStation
                          ) {
                            if (viaCount == 0) {
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                              viaCount++
                            }


                          }
                        }
                        break;
                      }
                    } else if (this.SpiceDirect == true) {

                      let depindexd = 0;
                      for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList.length; cb++) {
                        if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                          depindexd = cb;
                          break;
                        }
                      }
                      //meal on first leg.....baggage and infant on entire journey
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depindexd].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depindexd].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depindexd].SSRLegList[h].LegKey.ArrivalStation
                          ) {
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;

                          }
                        }
                        break;
                      }


                    }
                  } else {
                    if (this.SpiceViaT == true && z + 1 <= this.DepartureInformationProperties.length) {

                      let depinde = 0;
                      for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList.length; cb++) {
                        if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                          depinde = cb;
                          break;
                        }
                      }
                      //in via match the 
                      //meal on first leg.....baggage and infant on entire journey
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depinde].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depinde].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depinde].SSRLegList[h].LegKey.ArrivalStation
                          ) {
                            if (viaCount == 0) {
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                              viaCount++;
                            }
                            //via 0
                          }
                        }
                        break;
                      }
                    }
                  }
                  if (this.ReturnInformationProperties.length == 1) {
                    if (this.SpiceRViaT == true) {

                      let retindex = 0;
                      for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList.length; cb++) {
                        if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                          retindex = cb;
                          break;
                        }
                      }
                      //meal on first leg.....baggage and infant on entire journey
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retindex].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retindex].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retindex].SSRLegList[h].LegKey.ArrivalStation
                          ) {
                            if (rviaCount == 0) {
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                              rviaCount++;
                            }

                          }
                        }
                        break;
                      }
                    }
                  } else {
                    if (this.SpiceRViaT == true && z + 1 > this.DepartureInformationProperties.length) {

                      let retinde = 0;
                      for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList.length; cb++) {
                        if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                          retinde = cb;
                          break;
                        }
                      }
                      //meal on first leg.....baggage and infant on entire journey
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retinde].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retinde].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retinde].SSRLegList[h].LegKey.ArrivalStation
                          ) {
                            if (rviaCount == 0) {
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                              this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                              rviaCount++;
                            }

                          }
                        }
                        break;
                      }
                    }
                  }

                  //if (this.seatListSpice != null) {

                  //  for (let y = 0; y < this.seatListSpice.length; y++) {
                  //    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
                  //      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
                  //      //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
                  //      //  return (ele.availability != null || ele.availability == "0");
                  //      //})
                  //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                  //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatbtn = true;
                  //      //break;
                  //    }
                  //  }

                  //}

                }
              }

              if (this.ssrSpice != null) {
                if (this.SpiceConnecting == true || this.SpiceRConnecting == true || this.SpiceRDirect == true) {
                  //meal on first leg.....baggage and infant on both segments
                  if (this.SpiceConnecting == true && z + 1 <= this.DepartureInformationProperties.length) {
                    let depcindex = 0;
                    for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList.length; cb++) {
                      if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                        depcindex = cb;
                        break;
                      }
                    }
                    if (this.DepartureInformationProperties.length == 1) {
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depcindex].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depcindex].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[depcindex].SSRLegList[h].LegKey.ArrivalStation) {
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                          }
                        }
                        break;
                      }
                    } else {
                      //let depcinde = 0;
                      //for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList.length; cb++) {
                      //  if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[0].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                      //    depcinde = cb;
                      //    break;
                      //  }
                      //}

                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        /*for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList.length; h++) {*/
                        /*if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList[h].SSRLegList.length > 0) {*/
                        /*for (let v = 0; v < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList[h].SSRLegList.length; v++) {*/
                        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                          && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;

                          if (connectCount == 0) {
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                            connectCount++;
                          }
                          /*dconnecting = true;*/
                          break;
                          /*}*/
                          /*}*/

                          //}
                        }
                      }
                    }
                  } else if (this.SpiceRConnecting == true && z + 1 > this.DepartureInformationProperties.length) {
                    let retcindex = 0;
                    for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList.length; cb++) {
                      if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                        retcindex = cb;
                        break;
                      }
                    }
                    if (this.ReturnInformationProperties.length == 1) {
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retcindex].SSRLegList.length; h++) {
                          if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retcindex].SSRLegList[h].LegKey.DepartureStation
                            && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[retcindex].SSRLegList[h].LegKey.ArrivalStation) {
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                          }
                        }
                        break;
                      }
                    } else {
                      //let retcind = 0;
                      //for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList.length; cb++) {
                      //  if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                      //    retcind = cb;
                      //    break;
                      //  }
                      //}

                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        //for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList.length; h++) {
                        //  if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList[h].SSRLegList.length > 0) {
                        //    for (let v = 0; v < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList[h].SSRLegList.length; v++) {

                        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                          && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;

                          if (rconnectCount == 0) {
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                            this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                            rconnectCount++;
                          }
                          /*rconnecting = true;*/
                          break;
                          //}
                          //  }
                          //  break;
                          //}
                        }


                      }
                    }
                  } else if (this.SpiceRDirect == true) {

                    //let depcind = 0;
                    //for (let cb = 0; cb < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList.length; cb++) {
                    //  if (this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[cb].SSRLegList.length > 0) {
                    //    depcind = cb;
                    //    break;
                    //  }
                    //}
                    if (this.ReturnInformationProperties.length == 1) {
                      for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
                        /*for (let h = 0; h < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[1].AvailablePaxSSRList[depcind].SSRLegList.length; h++) {*/
                        if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
                          && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
                          this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].mealbtn = true;
                          break;
                        }
                        //}

                      }
                    }



                  }


                  //if (this.seatListSpice != null) {

                  //  for (let y = 0; y < this.seatListSpice.length; y++) {
                  //    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
                  //      && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
                  //      //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
                  //      //  return (ele.availability != null || ele.availability == "0");
                  //      //})
                  //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                  //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatbtn = true;
                  //      //break;
                  //    }
                  //  }

                  //}

                }

              }

              if (this.seatListSpice != null) {

                for (let y = 0; y < this.seatListSpice.length; y++) {
                  if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
                    && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
                    //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
                    //  return (ele.availability != null || ele.availability == "0");
                    //})
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
                    this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatbtn = true;
                    //break;
                  }
                }

              }

            }
          }
        }









      }




      //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {

      //  if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length == 1) {
      //    this.SpiceDirect = true;

      //  } else if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 1) {
      //    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[0].flightNumber ==
      //      this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[1].flightNumber) {
      //      this.SpiceViaT = true;
      //    } else {
      //      this.SpiceConnecting = true;
      //    }
      //  }

      //}
      //else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

      //  for (let c = 0; c < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; c++) {

      //    if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length == 2) {

      //      if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport &&
      //        this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
      //        //departure segments
      //        this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
      //        this.SpiceDirect = true;
      //      }

      //      if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport &&
      //        this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
      //        //return segments
      //        this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
      //        this.SpiceRDirect = true;
      //      }

      //    } else if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 2) {

      //      if (this.bookingBaseData.flightProp.flightLocationInfo[0].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport) {
      //        //departure segments
      //        this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
      //      }

      //      if (this.bookingBaseData.flightProp.flightLocationInfo[0].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
      //        //departure segments
      //        this.DepartureInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
      //      }

      //      if (this.bookingBaseData.flightProp.flightLocationInfo[1].fromCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].fromAirport) {
      //        //return segments
      //        this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);
      //      }
      //      if (this.bookingBaseData.flightProp.flightLocationInfo[1].toCity.trim() == this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c].toAirport) {
      //        //return segments
      //        this.ReturnInformationProperties.push(this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[c]);

      //      }


      //    }

      //  }

      //}
      //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2 && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 2) {

      //  // for (let q = 0; q < this.DepartureInformationProperties.length; q++) {
      //  if (this.DepartureInformationProperties[0].flightNumber == this.DepartureInformationProperties[1].flightNumber) {
      //    this.SpiceViaT = true;
      //  } else {
      //    this.SpiceConnecting = true;
      //  }
      //  // }

      //  // for (let q = 0; q < this.ReturnInformationProperties.length; q++) {
      //  if (this.ReturnInformationProperties[0].flightNumber == this.ReturnInformationProperties[1].flightNumber) {
      //    this.SpiceRViaT = true;
      //  } else {
      //    this.SpiceRConnecting = true;
      //  }
      //  //}

      //}







      //if (this.bookingObj.bookingPassengerInfoProperties[j].passengerType != 3) {

      //  for (let z = 0; z < this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length; z++) {

      //    if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
      //      if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length == 1) {
      //        if (this.ssrSpice != null) {
      //          if (this.SpiceDirect == true) {
      //            for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {

      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

      //              }
      //            }
      //          }
      //        }

      //        if (this.seatListSpice != null) {

      //          for (let y = 0; y < this.seatListSpice.length; y++) {
      //            if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length == 1) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {

      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;

      //              }
      //            } else if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length > 1) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[1].ArrivalStation) {

      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;

      //              }
      //            }

      //          }




      //        }


      //      }
      //      else if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 1) {
      //        if (this.ssrSpice != null) {

      //          if (this.SpiceViaT == true) {
      //            //meal on first leg.....baggage and infant on entire journey
      //            for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

      //              }
      //            }

      //            if (this.seatListSpice != null) {

      //              for (let y = 0; y < this.seatListSpice.length; y++) {
      //                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
      //                  //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
      //                  //  return (ele.availability != null || ele.availability == "0");
      //                  //})
      //                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
      //                  //break;
      //                }
      //              }

      //            }

      //          }
      //        }

      //        if (this.ssrSpice != null) {
      //          if (this.SpiceConnecting == true) {
      //            //meal on first leg.....baggage and infant on both segments
      //            for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
      //              }
      //            }

      //            if (this.seatListSpice != null) {

      //              for (let y = 0; y < this.seatListSpice.length; y++) {
      //                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
      //                  //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
      //                  //  return (ele.availability != null || ele.availability == "0");
      //                  //})
      //                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
      //                  //break;
      //                }
      //              }

      //            }
      //          }
      //        }
      //      }

      //    }
      //    else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

      //      if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length == 2) {
      //        if (this.ssrSpice != null) {
      //          if (this.SpiceDirect == true) {
      //            for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {

      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

      //              }
      //            }
      //          }
      //        }

      //        if (this.seatListSpice != null) {

      //          for (let y = 0; y < this.seatListSpice.length; y++) {
      //            if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length == 1) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
      //                //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
      //                //  return (ele.availability != null || ele.availability == "0");
      //                //})
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
      //                //break;
      //              }
      //            } else if (this.seatListSpice[y].SeatAvailabilityResponse.Legs.length >= 2){
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation) {
      //                //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
      //                //  return (ele.availability != null || ele.availability == "0");
      //                //})
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
      //                //break;
      //              }
      //            }

      //          }

      //        }


      //      }
      //      else if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties.length > 2) {
      //        if (this.ssrSpice != null) {

      //          if (this.SpiceViaT == true) {
      //            //meal on first leg.....baggage and infant on entire journey
      //            for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;

      //              }
      //            }

      //            if (this.seatListSpice != null) {

      //              for (let y = 0; y < this.seatListSpice.length; y++) {
      //                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
      //                  //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
      //                  //  return (ele.availability != null || ele.availability == "0");
      //                  //})
      //                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
      //                  //break;
      //                }
      //              }

      //            }

      //          }
      //        }

      //        if (this.ssrSpice != null) {
      //          if (this.SpiceConnecting == true) {
      //            //meal on first leg.....baggage and infant on both segments
      //            for (let e = 0; e < this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList.length; e++) {
      //              if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.DepartureStation
      //                && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].LegKey.ArrivalStation) {
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].generalListSpice = this.ssrSpice.SSRAvailabilityForBookingResponse.SSRSegmentList[e].AvailablePaxSSRList;
      //                this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].baggagebtn = true;
      //              }
      //            }

      //            if (this.seatListSpice != null) {

      //              for (let y = 0; y < this.seatListSpice.length; y++) {
      //                if (this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].fromAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].DepartureStation
      //                  && this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].toAirport == this.seatListSpice[y].SeatAvailabilityResponse.Legs[0].ArrivalStation) {
      //                  //this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units = this.seatListJazeera[y].data[0].seatMap.decks[1].compartments.y.units.filter(ele => {
      //                  //  return (ele.availability != null || ele.availability == "0");
      //                  //})
      //                  this.bookingObj.bookingPassengerInfoProperties[j].sectorInformationProperties[z].seatListSpice = this.seatListSpice[y].SeatAvailabilityResponse;
      //                  //break;
      //                }
      //              }

      //            }

      //          }

      //        }
      //      }


      //    }


      //  }

      //}




    }

  }

  SpiceSeatMapclose(i, z) {
    //this.modalService.open(model, {
    //  size: 'lg',
    //})
    document.getElementById(`newmodelofseat${i}${z}`).classList.add("SpiceSeatmodel");
    /*document.getElementById("newmodelofseat").classList.remove(numofseatmodel);*/

  }
  mealclose(i, z) {

    document.getElementById(`mealpopup${i}${z}`).classList.add("numofseatmodel");

  }
  spiceMealList: any[] = [];
  PriceSum: number = 0;
  SpiceMealClick(iSector, fmeal) {
    this.mealListJ = [];
    this.spiceMealList = [];

    let ssrList = JSON.parse(JSON.stringify(this.bookingObj.bookingPassengerInfoProperties[iSector].sectorInformationProperties[fmeal].generalListSpice));
    if (this.bookingObj.bookingPassengerInfoProperties[iSector].sectorInformationProperties[fmeal].generalListSpice.length > 0) {
      for (let k = 0; k < ssrList.length; k++) {
        this.PriceSum = 0;
        if (ssrList[k].SSRCode == "VGSW") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}

        } else if (ssrList[k].SSRCode == "VGML") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "VCC6") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "VCC5") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "VCC2") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NVSW") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NVML") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NCC6") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NCC5") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NCC4") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NCC2") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "NCC1") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        } else if (ssrList[k].SSRCode == "CAKE") {
          this.spiceMealList.push(ssrList[k]);
          //if (ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSum += ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSum).toFixed(2);
          //}
        }
      }

      this.mealListJ = this.spiceMealList;
      document.getElementById(`mealpopup${iSector}${fmeal}`).classList.remove("numofseatmodel");
    }
    else {
      this.mealerror = true;
      this.baggageerror = false;
      document.getElementById("errormessage").style.visibility = "visible";
      setTimeout(() => {
        document.getElementById("errormessage").style.visibility = "hidden";

      }, 2000);
    }


  }

  spiceSelectMeal(i, f, m) {
    let mealfee = 0;
    let meal = "";
    let mealname = "";

    if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {

      mealname = this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      meal = this.mealListJ[m].SSRCode;
      mealfee = Number(this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.mealListJ[m].SSRCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = Number(this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);
      this.AmountPaid += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
      try {
        if (i == this.mealPersonIndex && this.mealSectorIndex == f) {


          document.getElementById(`mealselectid${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).innerHTML = "Select";
          document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.backgroundColor = "#39454B";
          document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.borderColor = "#39454B";
        }
      }
      catch (e) {

      }
      try {
        document.getElementById(`mealselectid${i}${f}${m}`).innerHTML = "Selected";
        document.getElementById(`mealselectbtn${i}${f}${m}`).style.borderColor = "var(--first-color-second)";
        document.getElementById(`mealselectbtn${i}${f}${m}`).style.backgroundColor = "var(--first-color-second)";
      }
      catch (e) {

      }

      this.mealPersonIndex = i;
      this.mealSectorIndex = f;
      this.mealListIndex = m;


      /*    for oneway*/
      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
        /*   check stops*/
        let pstype = "";
        if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
          pstype = "Adult";
        }
        else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
          pstype = "Child";
        }

        if (this.bookingBaseData.airSegment.length == 1) {
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee);
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].mealFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);

              this.balanceDue += (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee * this.priceCardDetails[u].currencyRate);
            }
          }
        } else if (this.bookingBaseData.airSegment.length > 1) {
          //connecting
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
                  if (d == 0) {
                    if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                      newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee;
                    }
                  }
                }
                //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
                //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                //  }
                //}

              }
            }
          }

          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].mealFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);

              this.balanceDue += (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee * this.priceCardDetails[u].currencyRate);
            }

          }

        }


        for (let r = 0; r < this.priceCardDetails.length; r++) {
          let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
          let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
          let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
          let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
          let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
          let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
          let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
          let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
          this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
        }

        /*   for return*/
        let basepriceTtl = 0;
        let taxpriceTtl = 0;
        let servicepriceTtl = 0;
        let dispriceTtl = 0;
        let ancipriceTtl = 0;
        let ancipricebagTtl = 0;
        let ancipricemealTtl = 0;
        let newpricetotalTtl = 0;

        for (let o = 0; o < this.priceCardDetails.length; o++) {
          basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
          taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
          servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
          dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
          ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
          ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
          ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
        }
        newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
        this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
        this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

        if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
          if (this.bookingBaseData.airSegment.length == 1) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = meal;
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = mealname;
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = mealfee;
            }
          } else if (this.bookingBaseData.airSegment.length > 1) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              if (this.SpiceDirect) {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                if (f == 0)
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
              } else if (this.SpiceConnecting) {

                if (f == 0) {
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = meal;
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = mealfee;
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = mealname;
                }

              } else {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = meal;
                if (f == 0)
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = mealfee;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = mealname;
              }

            }
          }
        }


      }

    } else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

      mealname = this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      meal = this.mealListJ[m].SSRCode;
      mealfee = Number(this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.mealListJ[m].SSRCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = Number(this.mealListJ[m].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);
      this.AmountPaid += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
      try {
        if (i == this.mealPersonIndex && this.mealSectorIndex == f) {


          document.getElementById(`mealselectid${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).innerHTML = "Select";
          document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.backgroundColor = "#39454B";
          document.getElementById(`mealselectbtn${this.mealPersonIndex}${this.mealSectorIndex}${this.mealListIndex}`).style.borderColor = "#39454B";
        }
      }
      catch (e) {

      }
      try {
        document.getElementById(`mealselectid${i}${f}${m}`).innerHTML = "Selected";
        document.getElementById(`mealselectbtn${i}${f}${m}`).style.borderColor = "var(--first-color-second)";
        document.getElementById(`mealselectbtn${i}${f}${m}`).style.backgroundColor = "var(--first-color-second)";
      }
      catch (e) {

      }

      this.bagPersonIndex = i;
      this.baglSectorIndex = f;
      this.bagListIndex = m;


      /*    round oneway*/
      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
        /*   check stops*/
        let pstype = "";
        if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
          pstype = "Adult";
        }
        else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
          pstype = "Child";
        }
        if (this.bookingBaseData.airSegment.length == 2) {
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee);
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].mealFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
              this.balanceDue += (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee * this.priceCardDetails[u].currencyRate);
            }
          }
        } else if (this.bookingBaseData.airSegment.length > 2) {
          //connecting
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            let connecting = 0;
            let Via = 0;
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

                  if ((this.SpiceViaT == true || this.SpiceConnecting == true || this.SpiceDirect) && d + 1 <= this.DepartureInformationProperties.length) {

                    for (let a = 0; a < this.DepartureInformationProperties.length; a++) {

                      if (this.DepartureInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].fromAirport
                        && this.DepartureInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].toAirport) {

                        if (this.DepartureInformationProperties.length == 1) {
                          if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                            newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee;
                          }
                        } else if (this.DepartureInformationProperties.length > 1) {
                          if (a == 0) {
                            if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                              newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee;
                            }
                          }
                        }
                      }
                    }
                  }

                  if ((this.SpiceRViaT == true || this.SpiceRConnecting == true || this.SpiceRDirect) && d + 1 > this.DepartureInformationProperties.length) {

                    for (let a = 0; a < this.ReturnInformationProperties.length; a++) {

                      if (this.ReturnInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].fromAirport
                        && this.ReturnInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].toAirport) {
                        if (this.ReturnInformationProperties.length == 1) {

                          if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                            newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee;
                          }
                        } else if (this.ReturnInformationProperties.length > 1) {
                          if (a == 0) {
                            if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                              newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].mealFee;
                            }
                          }
                        }
                      }
                    }
                  }
                  //if (d == 0) {
                  //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                  //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                  //  }
                  //}


                  //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
                  //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                  //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                  //  }
                  //}

                }
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].mealFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
              this.balanceDue += (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee * this.priceCardDetails[u].currencyRate);
            }
          }


        }


        for (let r = 0; r < this.priceCardDetails.length; r++) {
          let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
          let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
          let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
          let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
          let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
          let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
          let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
          let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
          this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
        }

        let basepriceTtl = 0;
        let taxpriceTtl = 0;
        let servicepriceTtl = 0;
        let dispriceTtl = 0;
        let ancipriceTtl = 0;
        let ancipricebagTtl = 0;
        let ancipricemealTtl = 0;
        let newpricetotalTtl = 0;

        for (let o = 0; o < this.priceCardDetails.length; o++) {
          basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
          taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
          servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
          dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
          ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
          ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
          ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
        }
        newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
        this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
        this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

        if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
          if (this.bookingBaseData.airSegment.length == 2) {
            // for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = meal;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = mealfee;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = mealname;
            //}
          } else if (this.bookingBaseData.airSegment.length > 2) {
            let depCount = 0;
            let retCount = 0;
            let d = f;
            for (; d < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; d++) {

              if ((this.SpiceViaT == true || this.SpiceConnecting == true || this.SpiceDirect) && d + 1 <= this.DepartureInformationProperties.length) {

                for (let a = 0; a < this.DepartureInformationProperties.length; a++) {

                  if (this.DepartureInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].fromAirport
                    && this.DepartureInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].toAirport) {

                    if (this.DepartureInformationProperties.length == 1) {
                      depCount++;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
                      //if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //  newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //}
                    } else if (this.DepartureInformationProperties.length > 1) {
                      depCount++;
                      if (this.SpiceViaT == true) {
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                        if (a == 0)
                          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
                      } else if (this.SpiceConnecting == true) {
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                        if (a == 0)
                          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
                      }

                      //if (a == 0) {
                      //  if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //    newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //  }
                      //}
                    }
                  }
                }
              }
              if (depCount >= this.DepartureInformationProperties.length) {
                break;
              }

              if ((this.SpiceRViaT == true || this.SpiceRConnecting == true || this.SpiceRDirect) && d + 1 > this.DepartureInformationProperties.length) {

                for (let a = 0; a < this.ReturnInformationProperties.length; a++) {

                  if (this.ReturnInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].fromAirport
                    && this.ReturnInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].toAirport) {
                    if (this.ReturnInformationProperties.length == 1) {
                      retCount++;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
                      //if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //  newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //}
                    } else if (this.ReturnInformationProperties.length > 1) {
                      retCount++;
                      if (this.SpiceRViaT == true) {
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                        if (a == 0)
                          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
                      } else if (this.SpiceRConnecting == true) {
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].meal;
                        if (a == 0)
                          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealFee;
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].mealname;
                      }

                      //if (a = 0) {
                      //  if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //    newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //  }
                    }
                  }
                }
              }
              if (retCount == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length) {
                break;
              }
            }
          }

          //this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
          //if (f == 0)
          //  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
          //this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;


        }
      }


    }//2end

  }//end

  spiceSeats: any[] = [];
  spiceSeatMapOpen(i, f) {
    this.spiceSeats = [];
    let SpiceseatList = JSON.parse(JSON.stringify(this.seatListSpice));
    if (this.seatListSpice.length > 0) {


      for (let k = 0; k < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.EquipmentInfos[0].Compartments[0].Seats.length; k++) {

        this.spiceSeats.push(this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.EquipmentInfos[0].Compartments[0].Seats[k]);
        for (let g = 0; g < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.SeatGroupPassengerFees.length; g++) {
          if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.EquipmentInfos[0].Compartments[0].Seats[k].SeatGroup == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.SeatGroupPassengerFees[g].SeatGroup &&
            i == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.SeatGroupPassengerFees[g].PassengerNumber) {
            //let seatTotal = 0;
            //for (let v = 0; v < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.SeatGroupPassengerFees[g].PassengerFee.ServiceCharges.length; v++) {
            //  seatTotal += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.SeatGroupPassengerFees[g].PassengerFee.ServiceCharges[v].Amount;
            //}
            //this.spiceSeats[k].Amount = (seatTotal).toFixed(2);
            this.spiceSeats[k].Amount = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.SeatGroupPassengerFees[g].PassengerFee.ServiceCharges[0].Amount.toFixed(2);
            break;
          }
        }

      }

    }

    document.getElementById(`newmodelofseat${i}${f}`).classList.remove("SpiceSeatmodel");
  }

  spiceSeatSelection(i, f, k) {

    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatNumber
      = this.spiceSeats[k].SeatDesignator;
    //let group = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListJ.data[0].seatMap.decks[1].compartments.y.units[k].group;
    this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatFee
      = Number(this.spiceSeats[k].Amount);
    this.AmountPaid += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatFee;

    try {
      if (i == this.passngerIndex && f == this.sectorIndex) {
        document.getElementById(`link3button${this.passngerIndex}${this.sectorIndex}${this.seatIndex}`).classList.remove('classofseats');
        for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
          if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {
            if (i != y) {
              this.spiceSeats[k].Text = "Occupied";
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.EquipmentInfos[0].Compartments[0].Seats[k].Text = "Occupied";

            }
          }


        }
      }


    }
    catch (e) {
      console.log(e);
    }
    for (let y = 0; y < this.bookingObj.bookingPassengerInfoProperties.length; y++) {
      if (this.bookingObj.bookingPassengerInfoProperties[y].passengerType != 3) {

        if (i != y) {
          this.spiceSeats[k].Text = "Occupied";
          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatListSpice.EquipmentInfos[0].Compartments[0].Seats[k].Text = "Occupied";
        }
      }
    }
    document.getElementById(`link3button${i}${f}${k}`).classList.add('classofseats');
    this.passngerIndex = i;
    //console.log(this.passngerIndex, this.seatIndex, this.seatListIndex, this.seatselected);
    this.sectorIndex = f;
    /*this.seatListIndex = k;*/
    this.seatIndex = k;
    //console.log(this.bookingObj);
    /*    for oneway*/
    let pstype = "";
    if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
      pstype = "Adult";
    }
    else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
      pstype = "Child";
    }
    if (this.bookingBaseData.flightProp.flightLocationInfo.length >= 1) {
      /*   check stops*/
      if (this.bookingBaseData.airSegment.length == 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].seatFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
            this.balanceDue += (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatFee * this.priceCardDetails[u].currencyRate);
          }

        }

      }
      else if (this.bookingBaseData.airSegment.length > 1) {
        let newancifee = 0;
        for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
          if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
            for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
              newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].seatFee);
            }
          }
        }
        for (let u = 0; u < this.priceCardDetails.length; u++) {
          if (this.priceCardDetails[u].passengerType == pstype) {
            this.priceCardDetails[u].seatFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);
            this.balanceDue += (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatFee * this.priceCardDetails[u].currencyRate);
          }

        }
      }
    }

    for (let r = 0; r < this.priceCardDetails.length; r++) {
      //let baseprice = Number(this.priceCardDetails[r].indivisualBasePrice.substring(3));
      //let taxprice = Number(this.priceCardDetails[r].indivisualTaxes.substring(3));
      //let serviceprice = Number(this.priceCardDetails[r].serviceFee.substring(3));
      //let disprice = Number(this.priceCardDetails[r].discount.substring(3));
      //let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      //let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      //let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      //let newpricetotal = baseprice + taxprice + serviceprice + disprice + anciprice + ancipricebag + ancimealprice;
      //this.priceCardDetails[r].indivisualTotalPrice = this.currency + newpricetotal;


      let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
      let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
      let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
      let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
      let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
      let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
      let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
      let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
      this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);

    }

    /*   for return*/



    let basepriceTtl = 0;
    let taxpriceTtl = 0;
    let servicepriceTtl = 0;
    let dispriceTtl = 0;
    let ancipriceTtl = 0;
    let ancipricebagTtl = 0;
    let ancipricemealTtl = 0;
    let newpricetotalTtl = 0;
    for (let o = 0; o < this.priceCardDetails.length; o++) {
      //basepriceTtl += Number(this.priceCardDetails[o].indivisualBasePrice.substring(3));
      //taxpriceTtl += Number(this.priceCardDetails[o].indivisualTaxes.substring(3));
      //servicepriceTtl += Number(this.priceCardDetails[o].serviceFee.substring(3));
      //dispriceTtl += Number(this.priceCardDetails[o].discount.substring(3));
      //ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      //ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      //ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

      basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
      taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
      servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
      dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
      ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
      ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
      ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));

    }
    newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
    this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
    this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

    if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
      if (this.SpiceViaT == true) {
        for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
          this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatNumber = this.spiceSeats[k].SeatDesignator;

        }
      }
    } else {

      let depCount;
      if (this.SpiceRConnecting == true) {
        depCount = f;
      } else {
        depCount = 0;
      }

      let retCount = 0;
      let d = f;
      for (; d < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; d++) {

        if ((this.SpiceViaT == true || this.SpiceConnecting == true || this.SpiceDirect) && d + 1 <= this.DepartureInformationProperties.length) {

          for (let a = 0; a < this.DepartureInformationProperties.length; a++) {

            if (this.DepartureInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].fromAirport
              && this.DepartureInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].toAirport) {

              if (this.DepartureInformationProperties.length == 1) {
                depCount++;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].seatNumber = this.spiceSeats[k].SeatDesignator;
                //if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                //  newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                //}
              } else if (this.DepartureInformationProperties.length > 1) {
                depCount++;
                if (this.SpiceConnecting == true) {

                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatNumber = this.spiceSeats[k].SeatDesignator;
                } else if (this.SpiceViaT == true) {
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].seatNumber = this.spiceSeats[k].SeatDesignator;
                }
                //if (a == 0) {
                //  if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                //    newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                //  }
                //}
              }
            }
          }
        }
        if (depCount >= this.DepartureInformationProperties.length) {
          break;
        }

        if ((this.SpiceRViaT == true || this.SpiceRConnecting == true || this.SpiceRDirect) && d + 1 > this.DepartureInformationProperties.length) {

          for (let a = 0; a < this.ReturnInformationProperties.length; a++) {

            if (this.ReturnInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].fromAirport
              && this.ReturnInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].toAirport) {
              if (this.ReturnInformationProperties.length == 1) {
                retCount++;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].seatNumber = this.spiceSeats[k].SeatDesignator;

              } else if (this.ReturnInformationProperties.length > 1) {
                retCount++;
                if (this.SpiceRConnecting == true) {
                  //
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].seatNumber = this.spiceSeats[k].SeatDesignator;
                } else if (this.SpiceRViaT == true) {
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].seatNumber = this.spiceSeats[k].SeatDesignator;
                }

              }
            }
          }
        }
        if (retCount == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length) {
          break;
        }
      }

    }
  }

  spiceBagList: any[] = [];
  PriceSumB: number = 0;
  SpiceBaggageOpen(i, f) {
    this.baggageListJ = [];
    this.spiceBagList = [];
    this.PriceSumB = 0;

    let ssrBagList = JSON.parse(JSON.stringify(this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListSpice));
    if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListSpice.length > 0) {
      for (let k = 0; k < ssrBagList.length; k++) {
        this.PriceSumB = 0;
        //if (ssrBagList[k].SSRCode == "XTB1") {
        //  this.spiceBagList.push(ssrBagList[k]);
        //  if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
        //    for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
        //      this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
        //    }
        //    ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
        //  }

        //} else if (ssrBagList[k].SSRCode == "XTB2") {
        //  this.spiceBagList.push(ssrBagList[k]);
        //  if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
        //    for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
        //      this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
        //    }
        //    ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
        //  }
        //} else
        if (ssrBagList[k].SSRCode == "EB30") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        } else if (ssrBagList[k].SSRCode == "EB20") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        } else if (ssrBagList[k].SSRCode == "EB15") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        } else if (ssrBagList[k].SSRCode == "EB10") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        } else if (ssrBagList[k].SSRCode == "EB05") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        } else if (ssrBagList[k].SSRCode == "EB03") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        } else if (ssrBagList[k].SSRCode == "BAG1") {
          this.spiceBagList.push(ssrBagList[k]);
          //if (ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges) {
          //  for (let n = 0; n < ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges.length; n++) {
          //    this.PriceSumB += ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[n].Amount;
          //  }
          //  ssrBagList[k].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount = (this.PriceSumB).toFixed(2);
          //}
        }
      }

      this.baggageListJ = this.spiceBagList;
      document.getElementById(`mealpopup${i}${f}`).classList.remove("bagSpicemodel");

      if (this.baggageListJ.length == 0) {

        this.mealerror = false;
        this.baggageerror = true;
        document.getElementById("errormessage").style.visibility = "visible";
        setTimeout(() => {
          document.getElementById("errormessage").style.visibility = "hidden";

        }, 2000);
      } else {
        //this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].generalListJ = this.baggageListJ;
        document.getElementById(`baggagepopup${i}${f}`).classList.remove("bagSpicemodel");
      }

    }
    else {
      this.mealerror = false;
      this.baggageerror = true;
      document.getElementById("errormessage").style.visibility = "visible";
      setTimeout(() => {
        document.getElementById("errormessage").style.visibility = "hidden";

      }, 2000);
    }


  }

  spiceBaggageSelect(i, f, b) {
    let baggagefee = 0;
    let baggagecheck = "";
    let baggagename = "";
    if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {

      baggagecheck = this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      baggagename = this.spiceBagList[b].SSRCode;
      baggagefee = Number(this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.spiceBagList[b].SSRCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = Number(this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);
      this.AmountPaid += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
      try {
        if (i == this.bagPersonIndex && this.baglSectorIndex == f) {
          document.getElementById(`baggageselectid${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).innerHTML = "Select";
          document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.backgroundColor = "#39454B";
          document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.borderColor = "#39454B";
        }
      }
      catch (e) {

      }

      try {
        document.getElementById(`baggageselectid${i}${f}${b}`).innerHTML = "Selected";
        document.getElementById(`baggageselectbtn${i}${f}${b}`).style.borderColor = "var(--first-color-second)";
        document.getElementById(`baggageselectbtn${i}${f}${b}`).style.backgroundColor = "var(--first-color-second)";
      }
      catch (e) {
      }

      this.bagPersonIndex = i;
      this.baglSectorIndex = f;
      this.bagListIndex = b;


      /*    for oneway*/
      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
        /*   check stops*/
        let pstype = "";
        if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
          pstype = "Adult";
        }
        else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
          pstype = "Child";
        }

        if (this.bookingBaseData.airSegment.length == 1) {
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee);
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].baggageFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);

              this.balanceDue += (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee * this.priceCardDetails[u].currencyRate);
            }
          }
        } else if (this.bookingBaseData.airSegment.length > 1) {
          //connecting
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
                  if (d == 0) {
                    if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                      newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                    }
                  }
                }
                //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
                //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                //  }
                //}

              }
            }
          }

          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].baggageFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);

              this.balanceDue += (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee * this.priceCardDetails[u].currencyRate);
            }

          }

        }


        for (let r = 0; r < this.priceCardDetails.length; r++) {
          let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
          let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
          let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
          let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
          let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
          let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
          let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
          let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
          this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
        }

        /*   for return*/
        let basepriceTtl = 0;
        let taxpriceTtl = 0;
        let servicepriceTtl = 0;
        let dispriceTtl = 0;
        let ancipriceTtl = 0;
        let ancipricebagTtl = 0;
        let ancipricemealTtl = 0;
        let newpricetotalTtl = 0;

        for (let o = 0; o < this.priceCardDetails.length; o++) {
          basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
          taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
          servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
          dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
          ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
          ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
          ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
        }
        newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
        this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
        this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);
        if (this.bookingBaseData.flightProp.flightLocationInfo.length == 1) {
          if (this.bookingBaseData.airSegment.length == 1) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = baggagename;
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
              this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagecheck;
            }
          } else if (this.bookingBaseData.airSegment.length > 1) {
            for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
              if (this.SpiceDirect) {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                if (f == 0)
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
              } else if (this.SpiceConnecting) {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = baggagename;
                if (f == 0)
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagecheck;
              } else {
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = baggagename;
                if (f == 0)
                  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
                this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagecheck;
              }

            }
          }
        }


      }

    } else if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

      baggagecheck = this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      baggagename = this.spiceBagList[b].SSRCode;
      baggagefee = Number(this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.spiceBagList[b].SSRCode;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].ChargeDetail;
      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = Number(this.spiceBagList[b].PaxSSRPriceList[0].PaxFee.ServiceCharges[0].Amount);
      this.AmountPaid += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
      try {
        if (i == this.bagPersonIndex && this.baglSectorIndex == f) {
          document.getElementById(`baggageselectid${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).innerHTML = "Select";
          document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.backgroundColor = "#39454B";
          document.getElementById(`baggageselectbtn${this.bagPersonIndex}${this.baglSectorIndex}${this.bagListIndex}`).style.borderColor = "#39454B";
        }
      }
      catch (e) {

      }
      try {
        document.getElementById(`baggageselectid${i}${f}${b}`).innerHTML = "Selected";
        document.getElementById(`baggageselectbtn${i}${f}${b}`).style.borderColor = "var(--first-color-second)";
        document.getElementById(`baggageselectbtn${i}${f}${b}`).style.backgroundColor = "var(--first-color-second)";
      }
      catch (e) {
      }

      this.bagPersonIndex = i;
      this.baglSectorIndex = f;
      this.bagListIndex = b;


      /*    round oneway*/
      if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
        /*   check stops*/
        let pstype = "";
        if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 1) {
          pstype = "Adult";
        }
        else if (this.bookingObj.bookingPassengerInfoProperties[i].passengerType == 2) {
          pstype = "Child";
        }
        if (this.bookingBaseData.airSegment.length == 2) {
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                newancifee += Number(this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee);
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].baggageFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);

              this.balanceDue += (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee * this.priceCardDetails[u].currencyRate);
            }
          }
        } else if (this.bookingBaseData.airSegment.length > 2) {
          //connecting
          let newancifee = 0;
          for (let e = 0; e < this.bookingObj.bookingPassengerInfoProperties.length; e++) {
            let connecting = 0;
            let Via = 0;
            if (this.bookingObj.bookingPassengerInfoProperties[e].passengerType == this.bookingObj.bookingPassengerInfoProperties[i].passengerType) {
              for (let d = 0; d < this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties.length; d++) {
                if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {

                  if ((this.SpiceViaT == true || this.SpiceConnecting == true || this.SpiceDirect) && d + 1 <= this.DepartureInformationProperties.length) {

                    for (let a = 0; a < this.DepartureInformationProperties.length; a++) {

                      if (this.DepartureInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].fromAirport
                        && this.DepartureInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].toAirport) {

                        if (this.DepartureInformationProperties.length == 1) {
                          if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                            newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                          }
                        } else if (this.DepartureInformationProperties.length > 1) {
                          if (a == 0) {
                            if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                              newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                            }
                          }
                        }
                      }
                    }
                  }

                  if ((this.SpiceRViaT == true || this.SpiceRConnecting == true || this.SpiceRDirect) && d + 1 > this.DepartureInformationProperties.length) {

                    for (let a = 0; a < this.ReturnInformationProperties.length; a++) {

                      if (this.ReturnInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].fromAirport
                        && this.ReturnInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].toAirport) {
                        if (this.ReturnInformationProperties.length == 1) {

                          if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                            newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                          }
                        } else if (this.ReturnInformationProperties.length > 1) {
                          if (a == 0) {
                            if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                              newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                            }
                          }
                        }
                      }
                    }
                  }
                  //if (d == 0) {
                  //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                  //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                  //  }
                  //}


                  //if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
                  //  if (this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggagebtn == true) {
                  //    newancifee += this.bookingObj.bookingPassengerInfoProperties[e].sectorInformationProperties[d].baggageFee;
                  //  }
                  //}

                }
              }
            }
          }
          for (let u = 0; u < this.priceCardDetails.length; u++) {
            if (this.priceCardDetails[u].passengerType == pstype) {
              this.priceCardDetails[u].baggageFee = this.currency + (newancifee * this.priceCardDetails[u].currencyRate).toFixed(2);

              this.balanceDue += (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee * this.priceCardDetails[u].currencyRate);
            }
          }


        }


        for (let r = 0; r < this.priceCardDetails.length; r++) {
          let baseprice = Number(this.priceCardDetails[r].agencyBasePrice.substring(3));
          let taxprice = Number(this.priceCardDetails[r].agencyTaxes.substring(3));
          let serviceprice = Number(this.priceCardDetails[r].agencyServiceFee.substring(3));
          let disprice = Number(this.priceCardDetails[r].agencyDiscount.substring(3));
          let anciprice = Number(this.priceCardDetails[r].seatFee.substring(3));
          let ancimealprice = Number(this.priceCardDetails[r].mealFee.substring(3));
          let ancipricebag = Number(this.priceCardDetails[r].baggageFee.substring(3));
          let newpricetotal = (baseprice + taxprice + serviceprice + anciprice + ancipricebag + ancimealprice) - disprice;
          this.priceCardDetails[r].agencyTotalPrice = this.currency + newpricetotal.toFixed(2);
        }

        let basepriceTtl = 0;
        let taxpriceTtl = 0;
        let servicepriceTtl = 0;
        let dispriceTtl = 0;
        let ancipriceTtl = 0;
        let ancipricebagTtl = 0;
        let ancipricemealTtl = 0;
        let newpricetotalTtl = 0;

        for (let o = 0; o < this.priceCardDetails.length; o++) {
          basepriceTtl += Number(this.priceCardDetails[o].agencyBasePrice.substring(3));
          taxpriceTtl += Number(this.priceCardDetails[o].agencyTaxes.substring(3));
          servicepriceTtl += Number(this.priceCardDetails[o].agencyServiceFee.substring(3));
          dispriceTtl += Number(this.priceCardDetails[o].agencyDiscount.substring(3));
          ancipriceTtl += Number(this.priceCardDetails[o].seatFee.substring(3));
          ancipricemealTtl += Number(this.priceCardDetails[o].mealFee.substring(3));
          ancipricebagTtl += Number(this.priceCardDetails[o].baggageFee.substring(3));
        }
        newpricetotalTtl = (basepriceTtl + taxpriceTtl + servicepriceTtl + ancipriceTtl + ancipricebagTtl + ancipricemealTtl) - dispriceTtl;
        this.totalANCIConv = this.currency + (ancipriceTtl + ancipricemealTtl + ancipricebagTtl).toFixed(2);
        this.totalPriceConv = this.currency + newpricetotalTtl.toFixed(2);

        if (this.bookingBaseData.flightProp.flightLocationInfo.length == 2) {
          if (this.bookingBaseData.airSegment.length == 2) {
            // for (let f = 0; f < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; f++) {
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = baggagename;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = baggagefee;
            this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = baggagecheck;
            //}
          } else if (this.bookingBaseData.airSegment.length > 2) {
            let depCount = 0;
            let retCount = 0;
            let d = f;
            for (; d < this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length; d++) {

              if ((this.SpiceViaT == true || this.SpiceConnecting == true || this.SpiceDirect) && d + 1 <= this.DepartureInformationProperties.length) {

                for (let a = 0; a < this.DepartureInformationProperties.length; a++) {

                  if (this.DepartureInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].fromAirport
                    && this.DepartureInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].toAirport) {

                    if (this.DepartureInformationProperties.length == 1) {
                      depCount++;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
                      //if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //  newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //}
                    } else if (this.DepartureInformationProperties.length > 1) {
                      depCount++;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                      if (a == 0)
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
                      //if (a == 0) {
                      //  if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //    newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //  }
                      //}
                    }
                  }
                }
              }
              if (depCount >= this.DepartureInformationProperties.length) {
                break;
              }
              if ((this.SpiceRViaT == true || this.SpiceRConnecting == true || this.SpiceRDirect) && d + 1 > this.DepartureInformationProperties.length) {

                for (let a = 0; a < this.ReturnInformationProperties.length; a++) {

                  if (this.ReturnInformationProperties[a].fromAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].fromAirport
                    && this.ReturnInformationProperties[a].toAirport == this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].toAirport) {
                    if (this.ReturnInformationProperties.length == 1) {
                      retCount++;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
                      //if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //  newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //}
                    } else if (this.ReturnInformationProperties.length > 1) {
                      retCount++;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
                      if (a == 0)
                        this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
                      this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;
                      //if (a = 0) {
                      //  if (this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggagebtn == true) {
                      //    newancifee += this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[d].baggageFee;
                      //  }
                    }
                  }
                }
              }
              if (retCount > this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties.length) {
                break;
              }
            }

            //this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageCheckIn;
            //if (f == 0)
            //  this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggageFee;
            //this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename = this.bookingObj.bookingPassengerInfoProperties[i].sectorInformationProperties[f].baggagename;

          }
        }
      }


    }//2end

  }//end

  

}

